import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// third party
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import './assets/scss/style.scss';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
